import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { filter, finalize, map, pipe } from 'rxjs';
import { CompanyDraftInvoiceOperationDTO } from 'src/app/pages/dashboards/files-clients/interface/invoice-operation.interface';
import { ServiceInfoClientService } from 'src/app/pages/dashboards/files-clients/service/service-info-client.service';
import { AddOperationToMinuteViewModel } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/interface/minute-request.interface';
import { MinuteRequestService } from 'src/app/pages/dashboards/files-clients/sub-page/minutes/service/minute-request.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-invoice-operation-to-minute-modal',
  templateUrl: './add-invoice-operation-to-minute-modal.component.html',
  styleUrls: ['./add-invoice-operation-to-minute-modal.component.scss']
})
export class AddInvoiceOperationToMinuteModalComponent implements OnInit {

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  public dataSource: MatTableDataSource<CompanyDraftInvoiceOperationDTO>;
  public operationsToAdd = new SelectionModel<CompanyDraftInvoiceOperationDTO>(true, [], false, (io1, io2) => io1.invoiceOperationId === io2.invoiceOperationId);
  public loadingOperations: boolean = false;

  public columns = [
    'selection',
    'folio',
    'downPaymentPercentage',
    'financedAmount',
    'transferAmount',
    'allInRate',
    'rate',
    'plazo',
    'createdAt'
  ];
  public draftInvoiceOperations: CompanyDraftInvoiceOperationDTO[] = [];

  constructor(private dialogRef: MatDialogRef<AddInvoiceOperationToMinuteModalComponent>,
    private serviceClient: ServiceInfoClientService,
    private minuteRequestService: MinuteRequestService,
    @Inject(MAT_DIALOG_DATA) public data: AddOperationToMinuteViewModel
  ) 
  {
    this.dataSource = new MatTableDataSource([]);
  }

  ngOnInit(): void {
    this.getDraftInvoiceOperations();
  }

  public getDraftInvoiceOperations() {
    this.loadingOperations = true;
    this.serviceClient.getDraftInvoiceOperationCompany(this.data.companyId)
    .pipe(
      map((data) => data.filter(o => o.minuteRequestId == null)),
      finalize(() => this.loadingOperations = false)
    )
    .subscribe({
      next: (res) => {
        this.setDataSource(res);
      }
    })
  }

  public addOperations() {
    const operationsId = this.operationsToAdd.selected.map(o => o.invoiceOperationId);
    Swal.fire({
      title: 'Agregando a la minuta',
      didOpen: () => {
        Swal.showLoading();
        this.minuteRequestService.insertFactoringOperationToMinute(this.data.minuteRequestId, operationsId)
        .subscribe({
          next: (res) => {
            this.showMessage(res.resultMessage, 'Success');
          },
          error: (err) => { 
            this.showMessage(err.error.resultMessage || 'Ha ocurrido un error', 'Error');
          }
        });    
      }
    })
  }

  private showMessage(resultMessage: string, status: 'Success' | 'Error') {
    if(status === 'Success'){
      Swal.fire({
        icon: 'success',
        title: resultMessage,
        allowEnterKey: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirmButtonText: 'OK',
      }).then((r) => {
        if(r.isConfirmed) {
          this.closeDialog();
        }
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: resultMessage
      });
    }
  }

  private setDataSource(operations: CompanyDraftInvoiceOperationDTO[]) {
    this.dataSource.data = operations;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
